export const TrackingInfo = {
  dataCategory: "header",
  dataAction: "click",
  dataLabel: ""
};
